import { BgsLeafletModule } from 'src/app/bgsLeaflet/public_api';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { DragDropDirective } from '../directives/dragAndDrop.directive';
import { EvBasketComponent } from './ev-basket/ev-basket.component';
import { EvContributeComponent } from './ev-contribute/ev-contribute.component';
import { EvExportComponent } from './ev-export/ev-export.component';
import { EvFilterComponent } from './ev-filter/ev-filter.component';
import { EvLayersComponent } from './ev-layers/ev-layers.component';
import { EvLoadingComponent } from './ev-loading/ev-loading.component';
import { EvMapComponent } from './ev-map/ev-map.component';
import { EvSearchComponent } from './ev-search/ev-search.component';
import { EvSidebarResultsComponent } from './ev-sidebar-results/ev-sidebar-results.component';
import { EvSidebarComponent } from './ev-sidebar/ev-sidebar.component';
import { NotificationComponent } from './notification/notification.component';
import { UserNotificationService } from './notification/userNotifications.service';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  OWL_DATE_TIME_FORMATS,
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';

const MY_MOMENT_FORMATS = {
  parseInput: 'DD/MM/YYYY, LT',
  fullPickerInput: 'DD/MM/YYYY, LT',
  datePickerInput: 'DD/MM/YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@NgModule({
  declarations: [],
  imports: [
    BgsLeafletModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    RouterModule,
    FormsModule,
    MatButtonModule,
    MatMenuModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatSliderModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule,
    BgsLeafletModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatInputModule,
    MatCardModule,
    MatRadioModule,
    MatToolbarModule,
    MatIconModule,
    MatExpansionModule,
    MatListModule,
    MatSlideToggleModule,
    MatTableModule,
    MatDividerModule,
    MatChipsModule,
    MatBadgeModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NotificationComponent,
    EvMapComponent,
    EvSidebarResultsComponent,
    EvSidebarComponent,
    EvLayersComponent,
    EvContributeComponent,
    EvSearchComponent,
    EvFilterComponent,
    EvExportComponent,
    EvBasketComponent,
    EvLoadingComponent,
    DragDropDirective,
  ],
  exports: [
    EvMapComponent,
    EvSidebarComponent,
    EvSidebarResultsComponent,
    EvLayersComponent,
    EvContributeComponent,
    EvSearchComponent,
    EvFilterComponent,
    EvExportComponent,
    EvBasketComponent,
  ],
  providers: [UserNotificationService, { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS }],
})
export class ComponentsModule {}
